import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ServicesPage.css';
// import handcuffImage from '../../assets/servicesimages/handcuff.jpg';
import Header from '../../components/Header/Header';
import PageBanner from '../../components/PageBanner/PageBanner';
import Footer from '../../components/Footer/Footer';
import { servicesData } from '../../data/services';

interface Service {
  id: string;
  title: string;
}

const ServicesPage: React.FC = () => {
  const { serviceId } = useParams<{ serviceId: string }>();
  const [selectedService, setSelectedService] = useState<string>('civil-law');
  const [expandedFaqIndex, setExpandedFaqIndex] = useState<number | null>(null);

  useEffect(() => {
    // If serviceId is present in URL, use it. Otherwise default to 'civil-law'
    if (serviceId) {
      setSelectedService(serviceId);
    } else {
      setSelectedService('civil-law');
    }
  }, [serviceId]);

  const services: Service[] = [
    { id: 'civil-law', title: 'Civil Law' },
    { id: 'property-law', title: 'Property Law' },
    { id: 'criminal-law', title: 'Criminal Law' },
    { id: 'banking-law', title: 'Banking Law' },
    { id: 'consumer-law', title: 'Consumer Law' },
    { id: 'insurance-law', title: 'Insurance Law' },
    { id: 'arbitration-law', title: 'Arbitration Law' },
    { id: 'chit-fund', title: 'Chit Fund Cases' },
    { id: 'debt-recovery-tribunal', title: 'Debt Recovery Tribunal' },
    { id: 'electricity-law', title: 'Electricity Law' },
  ];

  const content = servicesData[selectedService] || servicesData['civil-law'];

  return (
    <div className="services-page">
      <Header />
      <PageBanner
        badge="SERVICE"
        title={content.title}
        backgroundImage={require('../../assets/images/hero_bg_new2.jpg')}
        breadcrumbs={[
          { label: 'Advocate Kannan', path: '/' },
          { label: 'Services', path: '/services' },
          { label: content.title }
        ]}
      />
      <div className="services-page-container">
        {/* Left Section - Practice Areas */}
        <div className="practice-areas-section">
          <h2 className="practice-areas-title">Practice Areas</h2>
          <ul className="practice-areas-list">
            {services.map((service) => (
              <li
                key={service.id}
                className={`practice-area-item ${selectedService === service.id ? 'active' : ''
                  }`}
              >
                <Link to={`/services/${service.id}`} className="practice-area-link" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                  {service.title}
                  <span className="practice-area-arrow">→</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Section - Content */}
        <div className="service-content-section">

          {/* Content */}
          <div className="service-content">
            <h1 className="service-content-title">{content.title}</h1>

            <div className="service-subsection">
              <h3 className="service-subsection-title">{content.subSection.title}</h3>
              <p className="service-subsection-description">
                {content.subSection.description}
              </p>
            </div>

            <div className="service-features">
              {content.features.map((feature: any, index: number) => (
                <div key={index} className="service-feature">
                  {feature.title && <h4 className="service-feature-title">{feature.title}</h4>}
                  {feature.description && <p className="service-feature-description">{feature.description}</p>}
                  {feature.list && (
                    <ul className="service-feature-list">
                      {feature.list.map((item: string, i: number) => (
                        <li key={i} className="service-feature-item" dangerouslySetInnerHTML={{ __html: item }} />
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>

            {/* FAQ Section */}
            {content.faqs && content.faqs.length > 0 && (
              <div className="service-faq-section">
                <h3 className="service-subsection-title">Frequently Asked Questions</h3>
                <div className="faq-list">
                  {content.faqs.map((faq: any, index: number) => (
                    <div key={index} className={`faq-item ${expandedFaqIndex === index ? 'active' : ''}`}>
                      <div
                        className="faq-question"
                        onClick={() => setExpandedFaqIndex(expandedFaqIndex === index ? null : index)}
                      >
                        {faq.question}
                        <span className="faq-toggle-icon">{expandedFaqIndex === index ? '−' : '+'}</span>
                      </div>
                      <div className={`faq-answer ${expandedFaqIndex === index ? 'open' : ''}`}>
                        <div className="faq-answer-inner">
                          <p>{faq.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;

